import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card.tsx';
import { Button } from '../ui/button.tsx';
import { Input } from '../ui/input.tsx';
import { Label } from '../ui/label.tsx';
import { X, Shield, CheckCircle } from 'lucide-react';

interface AdminMember { 
    id: number; 
    Email: string; 
    FirstName: string; 
    LastName: string; 
    GraduationYear: number; 
    is_staff: boolean; 
    AssociationRole?: string; 
}

interface MemberEditModalProps {
    selectedMember: AdminMember | null;
    setSelectedMember: (value: AdminMember | null) => void;
    memberRoleInput: string;
    setMemberRoleInput: (value: string) => void;
    memberIsStaff: boolean;
    setMemberIsStaff: (value: boolean) => void;
    handleSaveMemberChanges: () => Promise<void>;
}

export function MemberEditModal({
    selectedMember,
    setSelectedMember,
    memberRoleInput,
    setMemberRoleInput,
    memberIsStaff,
    setMemberIsStaff,
    handleSaveMemberChanges
}: MemberEditModalProps) {
    if (!selectedMember) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 animate-in fade-in zoom-in duration-200">
            <Card className="w-full max-w-md bg-white shadow-2xl">
                <CardHeader className="flex flex-row justify-between items-start border-b">
                    <div>
                        <CardTitle>Üye Yetkilendirme</CardTitle>
                        <CardDescription>
                            {selectedMember.FirstName} {selectedMember.LastName}
                        </CardDescription>
                    </div>
                    <Button 
                        variant="ghost" 
                        size="icon" 
                        onClick={() => setSelectedMember(null)}
                    >
                        <X className="h-5 w-5"/>
                    </Button>
                </CardHeader>
                <CardContent className="space-y-6 pt-6">
                    {/* 1. ROL ATAMA KISMI */}
                    <div className="space-y-3">
                        <Label className="text-base font-semibold">Dernekteki Görevi</Label>
                        <p className="text-xs text-slate-500">
                            Kullanıcının yönetim kurulundaki veya dernekteki ünvanı. 
                            (Örn: Yönetim Kurulu Başkanı, Sayman)
                        </p>
                        <Input 
                            placeholder="Örn: Yönetim Kurulu Başkanı" 
                            value={memberRoleInput} 
                            onChange={(e) => setMemberRoleInput(e.target.value)}
                        />
                    </div>

                    <div className="border-t my-4"></div>

                    {/* 2. ADMİN YETKİSİ VERME KISMI */}
                    <div className="space-y-3">
                        <Label className="text-base font-semibold flex items-center gap-2">
                            <Shield className="h-4 w-4 text-red-600"/> 
                            Admin Paneline Erişim
                        </Label>
                        <div className="flex items-center justify-between bg-slate-50 p-3 rounded-lg border">
                            <div className="space-y-0.5">
                                <Label htmlFor="admin-mode" className="text-sm">
                                    Yönetici Yetkisi
                                </Label>
                                <p className="text-xs text-slate-500">
                                    Bu kullanıcı admin paneline giriş yapabilsin mi?
                                </p>
                            </div>
                            {/* Manuel Checkbox */}
                            <input 
                                id="admin-mode"
                                type="checkbox" 
                                className="w-5 h-5 accent-red-600 cursor-pointer"
                                checked={memberIsStaff}
                                onChange={(e) => setMemberIsStaff(e.target.checked)}
                            />
                        </div>
                    </div>

                    {/* KAYDET BUTONU */}
                    <div className="pt-4">
                        <Button 
                            className="w-full bg-blue-600 hover:bg-blue-700 text-white gap-2"
                            onClick={handleSaveMemberChanges}
                        >
                            <CheckCircle className="h-4 w-4" />
                            Kaydet ve Yetkilendir
                        </Button>
                        {!memberRoleInput && (
                            <p className="text-xs text-center text-amber-600 mt-2">
                                Not: Görev yazmadan sadece yetki verebilirsiniz.
                            </p>
                        )}
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
